<template>
	<ui-modal
		:name="$mx_getModalName"
		:load-success="loader.modalLoadSuccess"
		:load-fail="loader.loadFail"
		:load="loader.modalLoad"
		:title="titleModal"
		icon="fal fa-user-cog"
		size="xs"
	>
		<div class="modal-content">
			<template v-if="customerChangeOption">
				<ui-sponsor-selector
					v-if="!$mx_userIsBroker"
					v-model="form.sponsor"
					@input="customerHandler"
				/>

				<ui-deal-selector
					v-model="customerDeal"
					:data="form.sponsor"
					:disabled="desabledCustomerCondition"
					return-value="object"
					@input="stageAndStatusHandler"
				/>
			</template>

			<div class="stage-and-status-area">
				<div class="stage-area">
					<ui-select-2
						v-model="form.funnel_stage_id"
						label="Etapa:"
						:data="funnelStageOptions"
						:loading="loader.stageLoad"
						:disabled="desabledStageCondition || statusId"
						:show-footer="false"
						align="left"
						item-label="name"
						return-value="id"
						@input="statusHandler"
					/>
				</div>
				<div class="status-area">
					<ui-select-2
						v-model="form.funnel_stage_status_id"
						label="Status:"
						:data="funnelStageStatusOptions"
						:loading="loader.stageStatusLoad"
						:disabled="desabledSatusCondition"
						:show-footer="false"
						align="right"
						item-label="name"
						return-value="id"
					/>
				</div>
			</div>
		</div>

		<div v-if="historicalArea && isChangedStateAndSate && !hasLoading" class="modal-content historical-area">
			<ui-text-with-select-area title="Registrar atendimento:" label="Tipo:">
				<template #select>
					<ui-select-2
						v-model="historical.type"
						:data="historicalTypesOptions"
						:search="false"
						:disabled="desabledHistoricalCondition"
						:loading="loader.historicalTypesLoad"
						:show-footer="false"
						align="right"
						design="mgb-0"
						item-label="label"
						return-value="value"
						size="xs"
					/>
				</template>
				<template #text>
					<textarea
						v-model="historical.message"
						:disabled="desabledHistoricalCondition"
						placeholder="Digite..."
						rows="6"
					></textarea>
				</template>
			</ui-text-with-select-area>
		</div>

		<template #footer>
			<div class="cancel-buttons">
				<ui-modal-cancel-button :modalName="$mx_getModalName" :trackEvent="gtm.cancel"
					>Cancelar</ui-modal-cancel-button
				>
			</div>
			<ui-button
				:disabled="!canSubmit"
				type="button"
				design="md success mw-100"
				@click="submit"
				>Salvar</ui-button
			>
		</template>
	</ui-modal>
</template>

<script>
	import { funnel, task, dealHistorical } from '@/services/axios'
	import { mapGetters } from 'vuex'

	import { uiButton } from '@/components/ui/buttons'
	import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
	import { uiSelect2, uiTextWithSelectArea } from '@/components/ui/form'
	import { uiSponsorSelector, uiDealSelector } from '@/components/ui-facilita/selectors'

	import {
		helpersMixin,
		loaderMixin,
		alertMixin,
		modalMixin,
		permissionsMixin,
		utilMixin,
	} from '@/mixins'

	import * as conditions from './conditions'
	import { defaultGtm } from './default'

	const defaultForm = () => ({
		id: null,
		funnel_stage_id: null,
		funnel_stage_status_id: null,
		sponsor: null,
		customer_id: null,
		allow_fill: 0,
	})

	const defaultHistorical = () => ({
		message: null,
		type: null,
	})

	const defaultLoader = () => ({
		modalLoad: false,
		modalLoadSuccess: false,
		customerLoad: false,
		stageLoad: false,
		loadFail: false,
		stageStatusLoad: false,
		historicalTypesLoad: false,
	})

	const defaultOldStateAndStage = () => ({
		funnel_stage_id: null,
		funnel_stage_status_id: null,
	})

	export default {
		components: {
			uiModal,
			uiModalCancelButton,
			uiTextWithSelectArea,
			uiSelect2,
			uiButton,
			uiSponsorSelector,
			uiDealSelector,
		},

		mixins: [helpersMixin, loaderMixin, alertMixin, modalMixin, permissionsMixin, utilMixin],

		props: {
			name: {
				type: String,
				required: true,
			},

			customerChangeOption: {
				type: Boolean,
				default: false,
			},

			historicalArea: {
				type: Boolean,
				default: true,
			},

			successEvent: {
				type: String,
				default: ''
			}
		},

		data() {
			return {
				event: {},
				form: { ...defaultForm() },
				historical: { ...defaultHistorical() },
				customerDeal: {},
				loader: { ...defaultLoader() },
				staticCustomer: {},
				funnelStageOptions: [],
				funnelStageStatusOptions: [],
				historicalTypesOptions: [],
				userList: [],
				oldStageStatus: { ...defaultOldStateAndStage() },
				gtm: { ...defaultGtm() },
				statusId: null
			}
		},

		mounted() {
			this.$root.$on('modal-open-' + this.$mx_getModalName, async (payload, id) => {
				this.statusId = id
				this.reset()
				this.event = {...payload}
				/**
				 * Verificação da propriedade que define
				 * se o cliente será modificável ou não.
				 */
				if (!this.customerChangeOption && payload.id) {
					this.form.id = payload.id
					this.form.allow_fill = payload.allow_fill

					this.staticCustomerHandler(payload)
					this.form.customer_id = payload.customer_id

					this.$mx_setLoaderList(
						['stageLoad', 'stageStatusLoad', 'historicalTypesLoad'],
						true,
					)

					// Verifica se o modal já fez a requisição de stages.
					if (!this.funnelStageOptions.length)
						this.funnelStageOptions = await this.getStages()

					this.form.funnel_stage_id = payload.funnel_stage_id

					await this.statusHandler(this.form.funnel_stage_id)
					this.form.funnel_stage_status_id = payload.funnel_stage_status_id

					// Verifica se o modal já fez a requisição dos tipos de atendimento.
					if (!this.historicalTypesOptions.length) await this.historicalTypesHandler()

					this.$mx_setLoaderList(
						['stageLoad', 'stageStatusLoad', 'historicalTypesLoad'],
						false,
					)
					//...
				} else {
					this.$mx_setLoader('historicalTypesLoad', true)
					if (!this.historicalTypesOptions.length) await this.historicalTypesHandler()
					this.$mx_setLoader('historicalTypesLoad', false)

					if (this.$mx_userIsBroker)
						this.form.sponsor = {
							group: this.user.group,
							id: this.user.broker_id,
						}
				}

				this.userList = []

				this.copyOldStateStage()
				// ...
			})
			this.$root.$on('close-modal-animation', (val, message) => {
				if(val) {
					this.closeAnimation()
					if(message) this.$mx_alertSuccess(message)
				}
				else {
					this.$mx_setLoader('loadFail', true)
					if(message) this.$mx_alertError(message)
					setTimeout(() => {
						this.$mx_closeModal()
					}, 900)
				}
			})
		},

		beforeDestroy() {
			this.$mx_closeModal()
			this.$root.$off('close-modal-animation')
			this.$root.$off('modal-open-' + this.$mx_getModalName)
		},

		computed: {
			...mapGetters('auth', { user: 'getUser' }),

			/**
			 * desabledCustomerCondition
			 * desabledStageCondition
			 * desabledSatusCondition
			 * desabledHistoricalCondition
			 * hasHistoricalNote
			 * canSubmit
			 */
			...conditions,

			titleModal() {
				const id = this.form.id ? ' – #' + this.form.id : ''
				return 'Alterar Etapa e Status' + id
			},

			getDealId() {
				return this.form.id
			},

			isChangedStateAndSate() {
				return JSON.stringify(this.newStegeStatus) != JSON.stringify(this.oldStageStatus)
			},

			newStegeStatus() {
				const { funnel_stage_id, funnel_stage_status_id } = this.form
				return {
					funnel_stage_id,
					funnel_stage_status_id: funnel_stage_status_id ? funnel_stage_status_id : null,
				}
			},

			customerPlaceholder() {
				return this.staticCustomer.customer_id + ' - ' + this.staticCustomer.name
			},

			validateDeal() {
				let form = this.$mx_copyObject(this.form)
				if (
					!this.$mx_hasValue(form.funnel_stage_status_id) ||
					form.funnel_stage_status_id.length == 0
				)
					delete form.funnel_stage_status_id
				delete form.sponsor
				return form
			},

			validateHistorical() {
				const type = this.historical.type
				if (this.$mx_hasValue(type))
					return {
						subject: 'Registro de Atendimento: ' + this.historicalTypeTitle(type),
						type: type,
						message: this.historical.message,
						deal_id: this.getDealId,
					}
				else return null
			},
		},

		methods: {
			copyOldStateStage() {
				const copy = this.$mx_copyObject(this.form)
				this.oldStageStatus = {
					funnel_stage_id: copy.funnel_stage_id,
					funnel_stage_status_id: copy.funnel_stage_status_id
						? copy.funnel_stage_status_id
						: null,
				}
			},

			historicalTypeTitle(type) {
				return this.historicalTypesOptions.find((his) => his.value == type).label
			},

			/**
			 * Handlers responsáveis por lidar com os Clientes, Etapas e Status.
			 */

			customerHandler(sponsor) {
				if (!this.$mx_hasValue(sponsor)) this.form.sponsor = null
				this.customerDeal = {}
				this.form.funnel_stage_id = null
				this.form.funnel_stage_status_id = null
				this.form.id = null
			},

			staticCustomerHandler(customer) {
				const { customer_id, customer_name } = customer
				this.staticCustomer = {
					customer_id: customer_id,
					name: customer_name,
				}
			},

			async stageAndStatusHandler() {
				const info = this.getInfoAboutCustomer()

				if (info && info.customer_id) {
					this.$mx_setLoaderList(['stageLoad', 'stageStatusLoad'], true)

					this.form.id = info.id

					this.form.customer_id = info.customer_id
					this.form.allow_fill = parseInt(info.allow_fill)

					if (!this.funnelStageOptions.length)
						this.funnelStageOptions = await this.getStages()

					this.form.funnel_stage_id = info.funnel_stage_id

					await this.statusHandler(info.funnel_stage_id)
					this.form.funnel_stage_status_id = info.stageStatusId

					this.$mx_setLoaderList(['stageLoad', 'stageStatusLoad'], false)

					this.copyOldStateStage()
					// ...
				} else {
					this.form.funnel_stage_id = null
					this.form.funnel_stage_status_id = null
				}
			},

			async statusHandler(id) {
				if (this.$mx_hasValue(id))
					this.funnelStageStatusOptions = this.getStatusByCustomerId(id)
				else {
					this.form.funnel_stage_id = null
					this.funnelStageStatusOptions = []
				}
				this.form.funnel_stage_status_id = null
			},

			async historicalTypesHandler() {
				this.historicalTypesOptions = await this.getHistoricalTypes()
			},

			/**
			 * Getters responsáveis por buscar Clientes, Etapas e Status.
			 */

			async getStages() {
				try {
					return (await funnel.getStages()).data
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			getInfoAboutCustomer() {
				const customer = this.customerDeal
				if (this.$mx_hasValue(customer))
					return {
						id: customer.id,
						funnel_stage_id: customer.funnel_stage_id,
						stageStatusId: customer.funnel_stage_status_id,
						customer_id: customer.customer_id,
						allow_fill: customer.allow_fill,
					}
				return null
			},

			getStatusByCustomerId(id) {
				if (id && this.funnelStageOptions.length) {
					const stage = Object.values(this.funnelStageOptions).find(
						(option) => option.id === parseInt(id),
					)
					return [...stage.status]
				}
				return []
			},

			async getHistoricalTypes() {
				try {
					const types = await task.getAll('types', null)
					return [...types.data[0].fields]
				} catch (error) {
					this.$mx_alertThisOnError(error)
					return []
				}
			},

			/**
			 * Reset dos campos do formulário.
			 */
			reset() {
				this.form = { ...defaultForm() }
				this.historical = { ...defaultHistorical() }
				this.loader = { ...defaultLoader() }
				this.oldStageStatus = { ...defaultOldStateAndStage() }
				this.staticCustomer = {}
				this.customerDeal = {}
			},

			closeAnimation() {
				setTimeout(() => {
					this.$mx_setLoader('modalLoadSuccess', true)
					setTimeout(() => {
						this.$mx_closeModal()
						this.$mx_reloadTablePage()
					}, 1000)
				}, 500)
			},

			async submit() {
				if (!this.canSubmit) return
				this.$mx_setLoader('modalLoad', true)

				try {
					if (this.hasHistoricalNote)
						await dealHistorical.create('', this.validateHistorical)

					// Gera evento para o funil alterar a posição do item
					// Enviando o id do item, id da etapa anterior, id e status da nova etapa.
					if (this.successEvent) {
						this.$root.$emit(this.successEvent, {
							old: this.oldStageStatus,
							new: this.form,
							event: this.event
						})
					}

					this.$gtm.trackEvent(this.gtm.submit)
					// ...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.$mx_setLoader('modalLoad', false)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
